import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'site.home',
    component: () => import('./views/Landing.vue'),
    meta: { layout: 'site' },
  },
  {
    path: '/noticias',
    name: 'site.noticias',
    component: () => import('./views/NoticiasList.vue'),
    meta: { layout: 'site' },
  },
  {
    path: '/noticias/:slug',
    name: 'site.noticia',
    component: () => import('./views/NoticiaDetalle.vue'),
    props: true,
    meta: { layout: 'site' },
  },
]

export default routes
